import { Icons } from "./icons";
import Navbar from "./Navbar";
import { httpsCallable } from "firebase/functions";
import { functions } from "./firebase";
import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuthState } from "react-firebase-hooks/auth";
import { messaging } from "./firebase";
import { getToken, deleteToken } from "firebase/messaging";
import { serverTimestamp, deleteDoc, setDoc } from "firebase/firestore";
import { db, auth } from "./firebase";
import {
  collection,
  onSnapshot,
  query,
  where,
  getDocs,
  getDoc,
  doc,
  writeBatch
} from "firebase/firestore";
import "./Dashboard.css";

import { onSnapshot as onSnapshotDoc } from "firebase/firestore";

const IOSSwitch = ({ value, onChange }) => {
  return (
    <div
      onClick={onChange}
      style={{
        width: "44px",
        height: "24px",
        borderRadius: "20px",
        background: value ? "#34c759" : "#444",
        position: "relative",
        cursor: "pointer",
        transition: "0.2s"
      }}
    >
      <div
        style={{
          width: "20px",
          height: "20px",
          borderRadius: "50%",
          background: "#fff",
          position: "absolute",
          top: "2px",
          left: value ? "22px" : "2px",
          transition: "0.2s",
          boxShadow: "0 2px 6px rgba(0,0,0,0.3)"
        }}
      />
    </div>
  );
};

function DashboardCucina({ localeTag: propLocale }) { 
  const navigate = useNavigate();
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
  const STATO_COLORE = {
  "inviato": {
      border: "#4aa3ff",
      bg: "rgba(74,163,255,0.15)",
      text: "#4aa3ff"
    },
    "in attesa": {
      bg: "rgba(255,59,48,0.12)",
      border: "#ff3b30",
      text: "#ff3b30"
    },
    "in preparazione": {
      border: "#ff8c00",
      bg: "rgba(255,140,0,0.15)",
      text: "#ffb74d"
    },
    "pronto": {
      border: "#00ff88",
      bg: "rgba(0,255,136,0.15)",
      text: "#00ff88"
    },
    "servito": {
      border: "#7a7a7a",
      bg: "rgba(160,160,160,0.12)",
      text: "#b8b8b8"
    }
  };

      const [user] = useAuthState(auth);
      const [localeTag, setLocaleTag] = useState(propLocale || "");

      const [ordini, setOrdini] = useState([]);
      const [menu, setMenu] = useState([]);
      const [infoLocale, setInfoLocale] = useState({});
      const isDemo = infoLocale?.demo === true;
      const tornaAllaDashboardDemo = () => {
  navigate(`/dashboard-gestore?locale=${localeTag}`);
};
      const [messaggio, setMessaggio] = useState("");
      const [notificationsEnabled, setNotificationsEnabled] = useState(false);
      const [filtroStato, setFiltroStato] = useState([]);

        const [localeBloccato, setLocaleBloccato] = useState(false);

      const unsubOrdiniRef = useRef(null);
const ordiniStampatiRef = useRef(new Set());
const primoSnapshotOrdiniRef = useRef(true);
const stampeInCodaRef = useRef(new Set());
const stampaAutomaticaRef = useRef(false);

// Coda reale delle stampe automatiche
const codaStampaRef = useRef([]);
const elaborazioneCodaRef = useRef(false);

    // Render singola card per colonna
    const renderCard = (card) => {
      const sc = STATO_COLORE[card.stato] || STATO_COLORE["inviato"];



      const totalePiatti = Object.values(card.gruppi || {})
        .flatMap(g => g.items || [])
        .reduce((acc, item) => acc + (item.quantity || item.quantita || 1), 0);



      const itemsFlat = card?.gruppi
        ? Object.values(card.gruppi)
            .flatMap(g => g.items || [])
            .filter(item => {
              const cat = getCategoriaByName(item.name || item.nome);

              // 🔥 BLOCCA SEMPRE categorie non selezionate
              if (categorieSelezionate.length > 0 && !categorieSelezionate.includes(cat)) return false;

              return true;
            })
        : [];

      const itemsFlatSorted = itemsFlat.length > 0
        ? ordinaPerStato(itemsFlat)
        : [];


      const hasAttesa = Object.values(card.gruppi || {})
        .flatMap(g => g.items || [])
        .some(item => item._statoItem === "in attesa");
      const isUrgente = hasAttesa;

      return (
            <div
              key={card._key}
                onTouchMove={(e) => {
    e.currentTarget.dataset.scrolling = "true";
  }}
              onClick={async (e) => {
                if (e.currentTarget.dataset.scrolling === "true") {
  e.currentTarget.dataset.scrolling = "false";
  return;
}
                if (e.defaultPrevented) return;
                try {
                  const batch = writeBatch(db);
                  card._ids.forEach(id => {
                    batch.update(doc(db, "ordini", id), {
                      vistoInCucina: true
                    });
                  });
                  await batch.commit();
                } catch (e) {
                  console.error("Errore vistoInCucina:", e);
                }

                // 🔥 SEMPRE apertura, MAI cambio automatico stato
                  setCardAperta(card);
              }}
              style={{
                position: "relative",
                background: ordiniNuovi[card._key]
                  ? "rgba(255, 193, 7, 0.15)"
                  : isUrgente
                    ? "rgba(255, 59, 48, 0.12)"
                    : "#1c1c1e",
                border: ordiniNuovi[card._key]
                  ? "2px solid #ffc107"
                  : `2px solid ${sc.border}`,
                borderRadius: "14px",
                padding: "10px 12px",
                marginBottom: "10px",
                cursor: "pointer",
                display: "flex",
                flexDirection: "column",
                gap: "6px",
                aspectRatio: vistaCompleta ? "auto" : "auto",
                animation: "none",
                transition: "transform 0.12s ease, box-shadow 0.12s ease",
                boxShadow: "0 6px 18px rgba(0,0,0,0.5)",
                animation: "none",
                userSelect: "none"
              }}
              
            >
              <div style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center"
              }}>
                <span style={{
                  fontSize: "0.8rem",
                  fontWeight: "700",
                  color: "#fff"
                }}>
                  {card.tipoOrdine === "ASPORTO"
                    ? `ASPORTO #${card.numeroOrdineAsporto}`
                    : `TAV. ${card.table || "?"}`}
                </span>
{card.tipoOrdine === "ASPORTO" && card.slotAsporto && (
  <span style={{
    marginLeft: "6px",
    fontSize: "0.7rem",
    fontWeight: "800",
    color: "#ffb74d",
    background: "rgba(255,183,77,0.14)",
    border: "1px solid rgba(255,183,77,0.35)",
    borderRadius: "999px",
    padding: "3px 7px",
    whiteSpace: "nowrap"
  }}>
    ⏰ {card.slotAsporto}
  </span>
)}
                <span style={{
                  fontSize: "0.65rem",
                  padding: "3px 7px",
                  borderRadius: "999px",
                  border: ordiniNuovi[card._key] ? "1px solid #ffc107" : `1px solid ${sc.border}`,
                  color: ordiniNuovi[card._key] ? "#000" : sc.text,
                  background: ordiniNuovi[card._key] ? "#ffc107" : "transparent",
                  textTransform: "uppercase",
                  fontWeight: "700",
                  flexShrink: 0
                }}>
                  {ordiniNuovi[card._key] ? "🔥 NUOVO" : card.stato}
                </span>
              </div>
              <div style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center"
              }}>
                <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
                  <span style={{
                    fontSize: "0.9rem",
                    fontWeight: "700",
                    color: "#ddd"
                  }}>
                    {totalePiatti} piatt{totalePiatti === 1 ? "o" : "i"}
                  </span>

                  {hasAttesa && (
                    <span style={{
                      fontSize: "0.7rem",
                      fontWeight: "700",
                      color: "#ff3b30"
                    }}>
                      ● In attesa
                    </span>
                  )}
                </div>
                <span style={{
                  fontSize: vistaCompleta ? "0.9rem" : "0.75rem",
                  color: "#999"
                }}>
                  <Icons.clock size={14} color="#aaa" /> {card.timestamp?.seconds
                    ? new Date(card.timestamp.seconds * 1000)
                        .toLocaleTimeString("it-IT", { hour: "2-digit", minute: "2-digit" })
                    : ""}
                </span>
              </div>

              {vistaCompleta && (
                <div
                  onClick={(e) => e.stopPropagation()}
                  onTouchMove={(e) => e.stopPropagation()}
                  style={{
                    marginTop: "6px",
paddingTop: "6px",
borderTop: "1px solid rgba(255,255,255,0.08)",

display: "flex",
flexDirection: "column",
gap: "4px",

overflowY: "auto",
overflowX: "hidden",

  maxHeight: "32vh",
minHeight: 0,

touchAction: "pan-y",

WebkitOverflowScrolling: "touch",
  overscrollBehavior: "contain",
  overscrollBehaviorY: "contain",

flex: 1,
                  }}
                >
                  <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                  <div style={{
                    fontSize: "0.75rem",
                    color: "#666",
                    marginBottom: "4px"
                  }}>
                    Tocca per selezionare
                  </div>
                  {itemsFlatSorted.map((item, i) => {
  const key = `${item._ordineId}_${item._localIdx}`;
  const isSelected = selezione[card._key]?.has(key);
  const psc = STATO_COLORE[item._statoItem] || STATO_COLORE["inviato"];

  return (
    <div
      key={key}
      onClick={(e) => {
        e.stopPropagation();
        toggleItem(card._key, item._ordineId, item._localIdx);
      }}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "8px 10px",
        borderRadius: "10px",
        cursor: "pointer",
        background: isSelected
          ? "rgba(10,132,255,0.18)"
          : "transparent",
        border: "1px solid rgba(255,255,255,0.06)",
        transition: "0.15s",
        marginBottom: "4px"
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <span style={{
          fontWeight: "700",
          color: "#aaa",
          minWidth: "22px"
        }}>
          {item.quantity || item.quantita || 1}x
        </span>

        <div>
          <div style={{
            color: item.custom ? "#ff6b6b" : "#fff",
            fontWeight: "600",
            fontSize: "0.9rem"
          }}>
            {item.name || item.nome}
          </div>

          {item.custom && (
            <div style={{
              fontSize: "0.75rem",
              color: "#ff6b6b"
            }}>
              {item.custom}
            </div>
          )}
        </div>
      </div>

      <span style={{
        fontSize: "0.65rem",
        padding: "4px 10px",
        borderRadius: "999px",
        background: psc.bg,
        color: psc.text,
        border: `1px solid ${psc.border}`,
        fontWeight: "700",
        textTransform: "uppercase",
        whiteSpace: "nowrap"
      }}>
        {item._statoItem}
      </span>
    </div>
  );
})}
                  </div>
                </div>
              )}
              <div style={{
                display: "flex",
                flexDirection: "column",
                gap: "6px"
              }}>

                {vistaCompleta && (
                  <div style={{
                    display: "flex",
                    gap: "6px",
                    marginTop: "4px"
                  }}>
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        aggiornaStato(card, "in attesa");
                      }}
                      style={{
                        flex: 1,
                        padding: "8px",
                        borderRadius: "10px",
                        border: "1px solid rgba(255,59,48,0.4)",
                        background: "rgba(255,59,48,0.15)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                      }}
                    >
                      <Icons.timer size={18} color="#ff3b30" />
                    </button>

                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        aggiornaStato(card, "in preparazione");
                      }}
                      style={{
                        flex: 1,
                        padding: "8px",
                        borderRadius: "10px",
                        border: "1px solid rgba(255,140,0,0.4)",
                        background: "rgba(255,140,0,0.15)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                      }}
                    >
                      <Icons.kitchen size={18} color="#ff8c00" />
                    </button>

                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        aggiornaStato(card, "pronto");
                      }}
                      style={{
                        flex: 1,
                        padding: "8px",
                        borderRadius: "10px",
                        border: "1px solid rgba(0,255,136,0.4)",
                        background: "rgba(0,255,136,0.15)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                      }}
                    >
                      <Icons.check size={18} color="#00ff88" />
                    </button>
                  </div>
                )}

{!isIOS && (
  <button
    onClick={(e) => {
      e.stopPropagation();
      stampaOrdine(card);
    }}
    style={{
      width: vistaCompleta ? "100%" : "auto",
      alignSelf: vistaCompleta ? "stretch" : "flex-end",
      height: vistaCompleta ? "32px" : "26px",
      padding: vistaCompleta ? "0 10px" : "0 8px",
      borderRadius: "8px",
      border: "1px solid rgba(255,255,255,0.15)",
      background: "rgba(255,255,255,0.04)",
      color: "#aaa",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "6px",
      fontSize: "0.75rem",
      fontWeight: "600",
      cursor: "pointer"
    }}
  >
    <Icons.print size={14} color="#aaa" />
    Stampa
  </button>
)}
              </div>
            </div>
        );
    };
  const [filtroTipo, setFiltroTipo] = useState(""); // "" | "ASPORTO"
  const audioRef = useRef(null);
  const [audioAbilitato, setAudioAbilitato] = useState(true);
const [showQrPrintConfig, setShowQrPrintConfig] = useState(false);
const [vistaCompleta, setVistaCompleta] = useState(false);
  const [vistaCategoria, setVistaCategoria] = useState(false);
  const [modaleCategorie, setModaleCategorie] = useState(false);
  const [categorieDisponibili, setCategorieDisponibili] = useState([]);
  const [categorieSelezionate, setCategorieSelezionate] = useState([]);

  // selezione piatti: { [cardKey]: Set<aggItemIndex> }
  const [selezione, setSelezione] = useState({});

  // card aperta nel drawer (null = nessuna)

  const [cardAperta, setCardAperta] = useState(null);

  const [sidebarOpen, setSidebarOpen] = useState(false);

  const [ordiniNuovi, setOrdiniNuovi] = useState({});
    const [stampaAutomatica, setStampaAutomatica] = useState(() => {
  return localStorage.getItem("stampaAutomaticaCucina") === "true";
});

useEffect(() => {
  stampaAutomaticaRef.current = stampaAutomatica;
}, [stampaAutomatica]);

  const VAPID = process.env.REACT_APP_VAPID_KEY;

  const togglePush = async () => {
    if (!messaging) {
  setMessaggio("⚠️ Notifiche non supportate su questo dispositivo/browser");
  setNotificationsEnabled(false);
  setTimeout(() => setMessaggio(""), 3000);
  return;
}
    if (window.__PUSH_LOCK) return;
    window.__PUSH_LOCK = true;
    const token = localStorage.getItem("kitchen_push_token") || null;

    if (notificationsEnabled) {
      // Rimozione token push notification
      try {
        if (token) {
          // 🔥 ORDINE CAMBIATO: prima unsubscribe, poi deleteToken
          const unsubscribe = httpsCallable(functions, "unsubscribeKitchenTopic");

          await unsubscribe({
            token,
            locale: localeTag
          });


          await deleteToken(messaging);
          // 🔥 aspetta che FCM si sincronizzi
          await new Promise(res => setTimeout(res, 1500));

          await deleteDoc(doc(db, "pushTokens", token));

          localStorage.removeItem("kitchen_push_token");
        }

        setNotificationsEnabled(false);
        setMessaggio("🔕 Notifiche disattivate");

      } catch (e) {
        console.error(e);
      }

    } else {
      // 🟢 ATTIVA
      try {
       if (!("Notification" in window)) {
  setMessaggio("⚠️ Notifiche non supportate su questo dispositivo");
  window.__PUSH_LOCK = false;
setTimeout(() => setMessaggio(""), 3000);
return;
}

const permission = await Notification.requestPermission();

if (permission !== "granted") {
  setMessaggio("⚠️ Permesso notifiche non concesso");
  setNotificationsEnabled(false);
  window.__PUSH_LOCK = false;
setTimeout(() => setMessaggio(""), 3000);
return;
}

const reg = await navigator.serviceWorker.ready;



        // 🔥 FORZA SEMPRE TOKEN NUOVO (fix Android definitivo)
        const newToken = await getToken(messaging, {
          vapidKey: VAPID,
          serviceWorkerRegistration: reg
        });

        if (!newToken) {
  setMessaggio("⚠️ Token notifiche non generato");
  setNotificationsEnabled(false);
  window.__PUSH_LOCK = false;
  setTimeout(() => setMessaggio(""), 3000);
  return;
}

        localStorage.setItem("kitchen_push_token", newToken);

        await setDoc(doc(db, "pushTokens", newToken), {
          ruolo: "cucina",
          locale: localeTag,
          token: newToken,
          createdAt: serverTimestamp()
        });


        const subscribe = httpsCallable(functions, "subscribeKitchenTopic");
        console.log("📲 TOKEN REGISTRATO:", newToken);

        const res = await subscribe({
          token: newToken,
          locale: localeTag
        });

        console.log("📡 subscribe result:", res?.data);

        setNotificationsEnabled(true);
        setMessaggio("🔔 Notifiche attive");
      } catch (e) {
        console.error("❌ Errore attivazione push:", e);
setMessaggio("❌ Errore attivazione notifiche");
setNotificationsEnabled(false);
      }
    }

    setTimeout(() => setMessaggio(""), 2000);
    setTimeout(() => {
      window.__PUSH_LOCK = false;
    }, 1500);
  };

  useEffect(() => {
    document.body.classList.add("kitchen-mode");
    return () => document.body.classList.remove("kitchen-mode");
  }, []);

    useEffect(() => {
      if (!localeTag) return;

      const ref = doc(db, "locali", localeTag);

      const unsub = onSnapshot(ref, (snap) => {
        if (!snap.exists()) return;

        const data = snap.data();

        // 🔴 BLOCCO LOCALE
        if (data.stato === "bloccato") {
          setLocaleBloccato(true);
          return;
        }

        // 🔴 BLOCCO CUCINA (NUOVO)
        if (data.nascondiCucina) {
          window.location.href = "/";
          return;
        }

        setLocaleBloccato(false);
      });

      return () => unsub();
      }, [localeTag]);

  // 🔥 RIPRISTINO TOKEN AUTOMATICO AL RIAVVIO
  useEffect(() => {
    const restorePush = async () => {
  if (!messaging) {
    console.warn("⚠️ Restore push saltato: messaging non supportato");
    setNotificationsEnabled(false);
    return;
  }

  const savedToken = localStorage.getItem("kitchen_push_token");
  if (!savedToken) return;

      try {
        const reg = await navigator.serviceWorker.ready;

        // 🔥 TOKEN REALE DEL BROWSER
        const currentToken = await getToken(messaging, {
          vapidKey: VAPID,
          serviceWorkerRegistration: reg
        });

        if (!currentToken) {
          console.log("⚠️ Nessun token attivo nel browser");
          return;
        }

        // 🔥 TOKEN DIVERSO → aggiorna tutto
        if (currentToken !== savedToken) {
          console.log("🔄 Token cambiato → aggiorno");

          try {
            const unsubscribeOld = httpsCallable(functions, "unsubscribeKitchenTopic");

            await unsubscribeOld({
              token: savedToken,
              locale: localeTag
            });
          } catch (e) {
            console.warn("⚠️ Errore unsubscribe vecchio token:", e);
          }

          try {
            await deleteDoc(doc(db, "pushTokens", savedToken));
          } catch (e) {
            console.warn("⚠️ Errore delete vecchio token:", e);
          }

          localStorage.setItem("kitchen_push_token", currentToken);

          await setDoc(doc(db, "pushTokens", currentToken), {
            ruolo: "cucina",
            locale: localeTag,
            token: currentToken,
            createdAt: serverTimestamp()
          });
        }


        // 🔥 ASSICURA CHE IL TOKEN ESISTA SU FIRESTORE
        const ref = doc(db, "pushTokens", currentToken);
        const snap = await getDoc(ref);

        if (!snap.exists()) {
          console.log("⚠️ Token mancante su Firestore → ricreo");

          await setDoc(ref, {
            ruolo: "cucina",
            locale: localeTag,
            token: currentToken,
            createdAt: serverTimestamp()
          });
        }

        // 🔥 RI-SUBSCRIBE SEMPRE (fix Android definitivo)
        const subscribe = httpsCallable(functions, "subscribeKitchenTopic");

        await subscribe({
          token: currentToken,
          locale: localeTag
        });

        setNotificationsEnabled(true);
        console.log("🔁 Token cucina sincronizzato");

      } catch (e) {
        console.error("❌ Errore restore push:", e);
      }
    };

    if (localeTag && infoLocale?.nome) {
      restorePush();
    }
    }, [localeTag, infoLocale?.nome]);

  // ── fetch locale ──
  useEffect(() => {
    if (!user) return;

    const run = async () => {
      try {
        // 🔥 NON sovrascrivere se già impostato da bootstrap
        if (localeTag && infoLocale?.nome) {
          console.log("🛑 Locale già impostato da PWA:", localeTag);

          const lSnap = await getDoc(doc(db, "locali", localeTag));
          if (lSnap.exists()) setInfoLocale(lSnap.data());

          return;
        }

        // fallback solo se non esiste
        const uSnap = await getDoc(doc(db, "utenti", user.uid));
        if (!uSnap.exists()) return;

        const tag = uSnap.data().localeTag;
        setLocaleTag(tag);

        const lSnap = await getDoc(doc(db, "locali", tag));
        if (lSnap.exists()) setInfoLocale(lSnap.data());

      } catch (e) {
        console.error("❌ Errore caricamento dati cucina:", e);
setMessaggio("❌ Errore caricamento dati locale");
setTimeout(() => setMessaggio(""), 3000);
      }
    };

    run();
  }, [user]);

  // ── fetch menu ──
  useEffect(() => {
    if (!localeTag) return;
    getDocs(collection(db, "menu")).then(snap => {
      setMenu(
        snap.docs
          .map(d => ({ id: d.id, ...d.data() }))
          .filter(m => m.localeTag?.trim().toLowerCase() === localeTag.trim().toLowerCase())
          .map(m => ({ id: m.id, name: m.nome || "", categoria: m.categoria || "" }))
      );
    });
  }, [localeTag]);

  useEffect(() => {
    if (!localeTag) return;
    getDocs(collection(db, "categorie")).then(snap => {
      const lista = snap.docs
        .map(d => ({ id: d.id, ...d.data() }))
        .filter(c => c.localeTag?.trim().toLowerCase() === localeTag.trim().toLowerCase())
        .map(c => c.nome || "");

      setCategorieDisponibili(lista);

      const salvate = localStorage.getItem(`categorieVisibili_${localeTag}`);
      setCategorieSelezionate(salvate ? JSON.parse(salvate) : lista);
    });
  }, [localeTag]);

  useEffect(() => {
    setCategorieSelezionate(prev => prev.filter(c => categorieDisponibili.includes(c)));
  }, [categorieDisponibili]);

  const getCategoriaByName = (name) => {
    const nomeNorm = String(name || "").trim().toLowerCase();
    return (
      menu.find(m => String(m.name || "").trim().toLowerCase() === nomeNorm)?.categoria || ""
    );
  };

  const statoOrder = ["inviato", "in attesa", "in preparazione", "pronto", "servito"];

  const statoMin = (stati) => {
    if (!stati || stati.length === 0) return "inviato";
    return stati.reduce((min, s) =>
      statoOrder.indexOf(s) < statoOrder.indexOf(min) ? s : min
    , stati[0]);
  };

  const ordinaPerStato = (items) => {
    return [...items].sort((a, b) =>
      statoOrder.indexOf(a._statoItem) - statoOrder.indexOf(b._statoItem)
    );
  };

  const processaCodaStampa = async () => {
  // Una sola elaborazione della coda alla volta
  if (elaborazioneCodaRef.current) return;

  elaborazioneCodaRef.current = true;

  try {
    while (codaStampaRef.current.length > 0) {
      // Se la stampa automatica viene disattivata, svuota la coda
      if (!stampaAutomaticaRef.current) {
        codaStampaRef.current.forEach(({ itemKeys }) => {
          itemKeys.forEach(key => {
            stampeInCodaRef.current.delete(key);
          });
        });

        codaStampaRef.current = [];
        break;
      }

      const prossimaStampa = codaStampaRef.current.shift();

      if (!prossimaStampa) continue;

      const { card, itemKeys } = prossimaStampa;

      // Segna gli item prima della stampa per impedire snapshot duplicati
      itemKeys.forEach(key => {
        ordiniStampatiRef.current.add(key);
        stampeInCodaRef.current.delete(key);
      });

      try {
        await stampaOrdine(card);
      } catch (errore) {
        console.error("❌ Errore stampa automatica:", errore);
      }

      // Pausa minima tra due comande consecutive
      await new Promise(resolve => setTimeout(resolve, 250));
    }
  } finally {
    elaborazioneCodaRef.current = false;

    // Gestisce eventuali comande aggiunte mentre la coda si chiudeva
    if (
      stampaAutomaticaRef.current &&
      codaStampaRef.current.length > 0
    ) {
      processaCodaStampa();
    }
  }
};

  const subscribeOrdini = (tag, audioOn) => {
    if (unsubOrdiniRef.current) unsubOrdiniRef.current();

    const q = query(collection(db, "ordini"), where("locale", "==", tag));
    let prevLen = 0;
    // let prevHash = "";

    unsubOrdiniRef.current = onSnapshot(q, (snap) => {

      const lista = snap.docs
        .map(d => ({ id: d.id, ...d.data() }))
        .filter(o => o.stato !== "pagamento" && o.stato !== "archiviato")
        .sort((a, b) => (a.timestamp?.seconds || 0) - (b.timestamp?.seconds || 0));

      // const currentHash = JSON.stringify(lista.map(o => o.id + o.stato));
      // if (currentHash === prevHash) return;
      // prevHash = currentHash;

      if (audioOn && prevLen > 0 && lista.length > prevLen) {
        audioRef.current?.play().catch(() => {});
      }
      prevLen = lista.length;

      const groupedByTable = {};

      lista.forEach(o => {
        const isAsporto = o.tipoOrdine === "ASPORTO";
        const tableNorm = String(o.table ?? "").trim();

        const cardKey = isAsporto
          ? `ASPORTO_${o.numeroOrdineAsporto}`
          : `TAV_${tableNorm}`;

        const itemsNorm = (o.items || []).map((item, idx) => ({
          ...item,
          quantity: item.quantity || item.quantita || 1,
          _statoItem:
            item.stato ||
            (o.itemStati && (o.itemStati[idx] || o.itemStati[String(idx)])) ||
            "inviato",
          _ordineId: o.id,
          _localIdx: idx,
        }));

        if (!groupedByTable[cardKey]) {
          groupedByTable[cardKey] = {
            _key: cardKey,
            id: cardKey,
            table: tableNorm,
            tipoOrdine: o.tipoOrdine,
            numeroOrdineAsporto: o.numeroOrdineAsporto,
slotAsporto: o.slotAsporto || null,
slotData: o.slotData || null,
slotQuantita: o.slotQuantita || null,
telefonoCliente: o.telefonoCliente || "",
timestamp: o.timestamp,
            totale: o.totale || 0,
            note: o.note || "",
            gruppi: {},
            _ids: [],
            _statiDocumenti: {},
            vistoInCucina: o.vistoInCucina ?? true
          };
        } else {
          groupedByTable[cardKey].vistoInCucina =
            groupedByTable[cardKey].vistoInCucina && (o.vistoInCucina ?? true);
        }

        groupedByTable[cardKey].gruppi[o.id] = {
          items: itemsNorm,
          tipoOrdine: o.tipoOrdine,
          stato: o.stato,
          telefonoCliente: o.telefonoCliente || ""
        };

        groupedByTable[cardKey]._ids.push(o.id);
        groupedByTable[cardKey]._statiDocumenti[o.id] = o.stato;
      });

      const cards = Object.values(groupedByTable);

      cards.forEach(card => {
        const tuttiStatiItem = Object.values(card.gruppi || {})
          .flatMap(g => (g.items || []).map(i => i._statoItem));
        card.stato = statoMin(tuttiStatiItem);
      });

      const nuovi = {};
      cards.forEach(card => {
        if (card.vistoInCucina === false) {
          nuovi[card._key] = true;
        }
      });

      setOrdiniNuovi(nuovi);
setOrdini(cards);

const getItemPrintKeys = (card) => {
  return Object.values(card.gruppi || {})
    .flatMap(g => g.items || [])
    .map(item => {
      const nome = item.name || item.nome || "";
      const qty = item.quantity || item.quantita || 1;
      const custom = item.custom || "";
      return `${item._ordineId}_${item._localIdx}_${nome}_${qty}_${custom}`;
    });
};

// 🖨️ EVITA DI STAMPARE ORDINI GIÀ PRESENTI AL PRIMO CARICAMENTO
if (primoSnapshotOrdiniRef.current) {
  cards.forEach(card => {
    getItemPrintKeys(card).forEach(key => {
      ordiniStampatiRef.current.add(key);
    });
  });

  primoSnapshotOrdiniRef.current = false;
  return;
}

// 🖨️ SE STAMPA AUTOMATICA DISATTIVA, MEMORIZZA COMUNQUE I PIATTI GIÀ VISTI
if (!stampaAutomaticaRef.current) {
  cards.forEach(card => {
    getItemPrintKeys(card).forEach(key => {
      ordiniStampatiRef.current.add(key);
    });
  });
  return;
}

// 🖨️ STAMPA AUTOMATICA DEI NUOVI PIATTI
cards.forEach(card => {
  if (card.vistoInCucina !== false) return;

  const itemKeys = getItemPrintKeys(card);

  const nuoveItemKeys = itemKeys.filter(key =>
    !ordiniStampatiRef.current.has(key) &&
    !stampeInCodaRef.current.has(key)
  );

  if (nuoveItemKeys.length === 0) return;

  // Impedisce che snapshot successivi rimettano gli stessi item in coda
  nuoveItemKeys.forEach(key => {
    stampeInCodaRef.current.add(key);
  });

  codaStampaRef.current.push({
    card,
    itemKeys: nuoveItemKeys
  });
});

// Avvia immediatamente la coda
processaCodaStampa();
    });
  };


  // ✅ Fix iOS/Android PWA: forza riaggancio ordini alla prima apertura e al ritorno in foreground
useEffect(() => {
  if (!localeTag) return;

  const resubscribe = () => {
    subscribeOrdini(localeTag, audioAbilitato);
  };

  // Primo aggancio immediato
  resubscribe();

  // Secondo aggancio ritardato: utile su iOS PWA appena aperta
  const t1 = setTimeout(resubscribe, 800);
  const t2 = setTimeout(resubscribe, 2000);

  const handleVisibility = () => {
    if (document.visibilityState === "visible") {
      resubscribe();
    }
  };

  window.addEventListener("focus", resubscribe);
  window.addEventListener("pageshow", resubscribe);
  document.addEventListener("visibilitychange", handleVisibility);

  return () => {
    clearTimeout(t1);
    clearTimeout(t2);
    window.removeEventListener("focus", resubscribe);
    window.removeEventListener("pageshow", resubscribe);
    document.removeEventListener("visibilitychange", handleVisibility);

    if (unsubOrdiniRef.current) {
      unsubOrdiniRef.current();
      unsubOrdiniRef.current = null;
    }
  };
}, [localeTag, audioAbilitato]);

  // ── selezione helpers ──
  const toggleItem = (cardId, ordineId, localIdx) => {
    const key = `${ordineId}_${localIdx}`;

    setSelezione(prev => {
      const s = new Set(prev[cardId] || []);
      s.has(key) ? s.delete(key) : s.add(key);
      return { ...prev, [cardId]: s };
    });
  };
  const selTutti = (cardId, items) =>
    setSelezione(prev => ({ ...prev, [cardId]: new Set(items) }));
  const deselTutti = (cardId) =>
    setSelezione(prev => ({ ...prev, [cardId]: new Set() }));

  // ── aggiornamento stato ──
  const aggiornaStato = async (card, nuovoStato) => {
    const selSet = selezione[card._key] || new Set();
    const hasSel = selSet.size > 0;
    // Calcola itemsFlat come nella render
    const itemsFlat = Object.values(card.gruppi || {}).flatMap(g => g.items || []);

    try {
      const batch = writeBatch(db);

      if (!hasSel) {
        // ── Tutto il gruppo ──
        for (const oid of card._ids) {
          const ref = doc(db, "ordini", oid);
          const snap = await getDoc(ref);
          const data = snap.data() || {};
          // Aggiorna direttamente lo stato di ogni item
const newItems = (data.items || []).map((item) => ({
  ...item,
  stato: nuovoStato
}));

const updateOrdine = {
  stato: nuovoStato,
  items: newItems
};

// Salva una sola volta il momento in cui tutto l'ordine diventa pronto
if (nuovoStato === "pronto" && !data.prontoAt) {
  updateOrdine.prontoAt = serverTimestamp();
}

batch.update(ref, updateOrdine);

if (
  data.tipoOrdine === "ASPORTO" &&
  data.numeroOrdineAsporto
) {
  const updateAsporto = {
    stato: nuovoStato
  };

  if (nuovoStato === "pronto" && !data.prontoAt) {
    updateAsporto.prontoAt = serverTimestamp();
  }

  batch.update(
    doc(
      db,
      "ordini_asporto",
      `${data.locale}_${data.numeroOrdineAsporto}`
    ),
    updateAsporto
  );
}
        }
        setMessaggio(`✅ Tavolo ${card.table || card.numeroOrdineAsporto} → "${nuovoStato}"`);
      } else {
        // ── Solo piatti selezionati ──
        // Raggruppa gli aggiornamenti per documento Firestore
        const updateMap = {}; // { ordineId: { [localIdx]: nuovoStato } }

        selSet.forEach(key => {
          const [ordineId, localIdx] = key.split("_");
          if (!updateMap[ordineId]) updateMap[ordineId] = {};
          updateMap[ordineId][localIdx] = nuovoStato;
        });

        for (const [oid, parziale] of Object.entries(updateMap)) {
          const ref = doc(db, "ordini", oid);
          const snap = await getDoc(ref);
          const data = snap.data() || {};
          const allItems = data.items || [];
          // Aggiorna solo gli item selezionati
          const newItems = allItems.map((item, i) =>
            parziale.hasOwnProperty(i) ? { ...item, stato: parziale[i] } : item
          );
          // Stato globale del documento = stato più urgente tra i piatti
          const statiTutti = newItems.map(i => i.stato || data.stato || "inviato");
          const nuovoStatoGlobale = statoMin(statiTutti);

const updateOrdine = {
  items: newItems,
  stato: nuovoStatoGlobale
};

// Se con questo aggiornamento tutti i piatti diventano pronti,
// salva il momento esatto una sola volta
if (
  nuovoStatoGlobale === "pronto" &&
  !data.prontoAt
) {
  updateOrdine.prontoAt = serverTimestamp();
}

batch.update(ref, updateOrdine);

// Sincronizza anche il tracking dell'ordine asporto
if (
  data.tipoOrdine === "ASPORTO" &&
  data.numeroOrdineAsporto
) {
  const updateAsporto = {
    stato: nuovoStatoGlobale
  };

  if (
    nuovoStatoGlobale === "pronto" &&
    !data.prontoAt
  ) {
    updateAsporto.prontoAt = serverTimestamp();
  }

  batch.update(
    doc(
      db,
      "ordini_asporto",
      `${data.locale}_${data.numeroOrdineAsporto}`
    ),
    updateAsporto
  );
}
        }

        setMessaggio(`✅ ${selSet.size} piatt${selSet.size === 1 ? "o" : "i"} → "${nuovoStato}"`);
        deselTutti(card._key);
      }

      await batch.commit();

      // 🔥 Sync realtime drawer aperto
setCardAperta(prev => {
  if (!prev || prev._key !== card._key) return prev;

  const gruppiAggiornati = { ...prev.gruppi };

  Object.values(gruppiAggiornati).forEach(gruppo => {
    gruppo.items = (gruppo.items || []).map(item => {
      const itemKey = `${item._ordineId}_${item._localIdx}`;

      // solo selezionati
      if (hasSel) {
        if (selSet.has(itemKey)) {
          return {
            ...item,
            _statoItem: nuovoStato
          };
        }

        return item;
      }

      // tutti i piatti
      return {
        ...item,
        _statoItem: nuovoStato
      };
    });
  });

  return {
    ...prev,
    gruppi: gruppiAggiornati,
    stato: nuovoStato
  };
});

      // 🔔 Push cumulativa ai camerieri — solo se "pronto" e ordine sala
      if (nuovoStato === "pronto" && card.tipoOrdine !== "ASPORTO") {

        // 💡 UX: se nessuna selezione e già pronto, non inviare push
        if (!hasSel && card.stato === "pronto" && nuovoStato === "pronto") return;

        // 🔥 BLOCCO ANTIDOPPIO
        if (window._lastReadyPush && Date.now() - window._lastReadyPush < 1500) {
          console.log("⛔ Push duplicata bloccata");
          return;
        }

        window._lastReadyPush = Date.now();

        try {
          const itemsTarget = hasSel
            ? itemsFlat.filter(item => {
                const key = `${item._ordineId}_${item._localIdx}`;
                return selSet.has(key);
              })
            : itemsFlat;
          console.log("🔥 itemsTarget:", itemsTarget);

          const grouped = {};
          itemsTarget.forEach(item => {
            const nome = item.name || item.nome || "Piatto";
            const qty = Number(item.quantity || item.quantita || 1);
            grouped[nome] = (grouped[nome] || 0) + qty;
          });

          const piatti = Object.entries(grouped).map(([nome, qty]) => ({ nome, qty }));
          // 🔥 DEBUG
          console.log("📢 piatti per push:", piatti);

          if (piatti.length > 0) {
            const tavolo = card.table || card.numeroOrdineAsporto || "?";
            const notifyReady = httpsCallable(functions, "notifyReadyCallable");
            const res = await notifyReady({
              locale: localeTag,
              tavolo: String(tavolo),
              piatti
            });
            console.log("✅ notifyReadyCallable result:", res?.data);
            if (!res?.data?.success) {
              console.warn("⚠️ notifyReadyCallable non riuscita:", res?.data);
            }
          }
        } catch (pushErr) {
          console.warn("⚠️ Errore costruzione push ready:", pushErr);
        }
      }

      setTimeout(() => setMessaggio(""), 3000);
    } catch (err) {
      console.error("❌", err);
      setMessaggio("❌ Errore aggiornamento");
      setTimeout(() => setMessaggio(""), 3000);
    }
  };

// ── stampa ──
const stampaOrdine = async (card) => {
  const righe = Object.values(card.gruppi || {})
  .flatMap(g => g.items || [])
  .filter(p => {
    if (!categorieSelezionate || categorieSelezionate.length === 0) return true;

    const cat = getCategoriaByName(p.name || p.nome);

    if (!cat) return true;

    return categorieSelezionate.includes(cat);
  });

  const tipo = card.tipoOrdine === "ASPORTO" ? "ASPORTO" : "TAVOLO";
const numero = card.tipoOrdine === "ASPORTO"
  ? `#${card.numeroOrdineAsporto}`
  : `${card.table || "?"}`;

const testo =
  "\x1B@" +              // init
  "\x1Ba\x01" +          // center
  "\x1D!\x11" +          // doppia larghezza + doppia altezza
  `${tipo} ${numero}\n` +
  "\x1D!\x00" +          // normale
  "------------------------------------------\n" +
  (card.slotAsporto ? `RITIRO: ${card.slotAsporto}\n` : "") +
  `STATO : ${String(card.stato || "").toUpperCase()}\n` +
  `DATA  : ${card.timestamp ? new Date(card.timestamp.seconds * 1000).toLocaleString("it-IT") : new Date().toLocaleString("it-IT")}\n` +
  "------------------------------------------\n" +
  "\x1Ba\x00" +          // left
  "\x1D!\x01" +          // altezza doppia
  righe.map(p => {
  const qty = p.quantity || p.quantita || 1;
  const nome = String(p.name || p.nome || "Piatto").toUpperCase();
  const stato = String(p._statoItem || p.stato || "inviato").toUpperCase();
  const custom = p.custom ? `\n   NOTE: ${p.custom}` : "";
return `${qty}x ${nome} [${stato}]${custom}`;
}).join("\n\n") +
  "\n" +
  "\x1D!\x00" +          // normale
  "\x1Ba\x01" +          // center
  "------------------------------------------\n" +
  (card.note ? `NOTE ORDINE:\n${card.note}\n` : "") +
  "\n\n\n\n" +
  "\x1DVB\x00";

  const base64 = btoa(unescape(encodeURIComponent(testo)));

  try {
    const res = await fetch("http://127.0.0.1:8080/print", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
  base64,
  locale: localeTag
})
    });

    if (!res.ok) throw new Error("HTTP " + res.status);

    setMessaggio("✅ Comanda inviata alla stampante");
    setTimeout(() => setMessaggio(""), 2500);
    return;
  } catch (err) {
    console.warn("Stampa APK non disponibile, uso stampa browser:", err);
  }

  const html = `
<div style="font-family:monospace;width:300px;padding:10px">
  <div style="text-align:center;border-bottom:2px dashed #000;padding-bottom:10px;margin-bottom:10px">
    <h2 style="margin:0;font-size:18px">${infoLocale.titolo || "COMANDA"}</h2>
  </div>
  <div style="margin-bottom:10px">
    <strong>Tavolo: ${card.table || "#" + card.numeroOrdineAsporto}</strong><br/>
    <strong>Stato: ${card.stato}</strong><br/>
    <strong>Data: ${card.timestamp ? new Date(card.timestamp.seconds * 1000).toLocaleString("it-IT") : new Date().toLocaleString("it-IT")}</strong>
  </div>
  <div style="border-top:1px dashed #000;border-bottom:1px dashed #000;padding:10px 0;margin:10px 0">
    ${righe.map(p => `<div style="margin-bottom:5px">
      <strong>${p.quantity || p.quantita || 1}x ${p.name || p.nome}</strong>${p._statoItem ? ` [${p._statoItem}]` : ""}<br/>
      ${p.custom ? `<em style="font-size:12px">${p.custom}</em><br/>` : ""}
    </div>`).join("")}
  </div>
  ${card.note ? `<div style="margin-top:10px"><strong>Note:</strong><br/>${card.note}</div>` : ""}
</div>`;

  const w = window.open("", "", "width=400,height=600");

if (!w) {
  setMessaggio("❌ Popup stampa bloccato. Verifica che QrPrint sia aperta e attiva.");
  setTimeout(() => setMessaggio(""), 3000);
  return;
}

w.document.write(`<html><head><title>Comanda</title></head><body>${html}</body></html>`);
w.document.close();

w.onload = () => {
  w.focus();
  w.print();
};
};


  const salvaCategorieVisibili = () => {
    localStorage.setItem(`categorieVisibili_${localeTag}`, JSON.stringify(categorieSelezionate));
    setModaleCategorie(false);
    setMessaggio("✅ Categorie aggiornate");
    setTimeout(() => setMessaggio(""), 2000);
  };

  // ── RENDER ──────────────────────────────────────────────────────────────────

  const cardsFiltrate = ordini.filter(o => {
    const matchStato = filtroStato.length === 0 || filtroStato.includes(o.stato);

    const matchTipo =
      !filtroTipo ||
      (filtroTipo === "ASPORTO" && o.tipoOrdine === "ASPORTO") ||
      (filtroTipo === "SALA" && o.tipoOrdine !== "ASPORTO");

    return matchStato && matchTipo;
  });




  const colonne = {
    "inviato": [],
    "in attesa": [],
    "in preparazione": [],
    "pronto": []
  };

  const colonneCategoria = {};

  cardsFiltrate.forEach(card => {
    const items = Object.values(card.gruppi || {})
      .flatMap(g => g.items || []);

    const groupedByCategoria = {};

    items.forEach(item => {
      const cat = getCategoriaByName(item.name || item.nome) || "Altro";

      if (!groupedByCategoria[cat]) {
        groupedByCategoria[cat] = [];
      }

      groupedByCategoria[cat].push(item);
    });

    Object.entries(groupedByCategoria).forEach(([cat, itemsCategoria]) => {

      // 🔥 FILTRO CATEGORIE DISABILITATE
      if (categorieSelezionate.length > 0 && !categorieSelezionate.includes(cat)) return;

      if (!colonneCategoria[cat]) colonneCategoria[cat] = [];

      colonneCategoria[cat].push({
        ...card,
        gruppi: {
          FILTRATO: {
            items: itemsCategoria
          }
        }
      });
    });
  });

  cardsFiltrate.forEach(card => {
    const stato = card.stato || "inviato";
    if (colonne[stato]) {
      colonne[stato].push(card);
    }
  });


  const countNuovi = cardsFiltrate.filter(card => {
    const items = Object.values(card.gruppi || {})
      .flatMap(g => g.items || []);

    return items.some(i => i._statoItem === "inviato");
  }).length;

  const countAttesa = cardsFiltrate.filter(card => {
    const items = Object.values(card.gruppi || {})
      .flatMap(g => g.items || []);

    return items.some(i => i._statoItem === "in attesa");
  }).length;

  return (
      <>
        {localeBloccato && (
          <div style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "#0f0f12",
            color: "#fff",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 999999,
            textAlign: "center"
          }}>
            <div style={{ fontSize: "3rem", marginBottom: "1rem" }}>🚫</div>
            <h2>Locale disattivato</h2>
            <p style={{ color: "#aaa" }}>Contatta l'amministratore</p>
          </div>
        )}
      {process.env.REACT_APP_ROLE !== "kitchen" && <Navbar />}
      <audio ref={audioRef} src="/notification.mp3" preload="auto" />

      <div className="kitchen-layout">

        {/* MOBILE SETTINGS BUTTON */}
<button
  className="kitchen-mobile-settings-btn"
  onClick={() => setSidebarOpen(prev => !prev)}
>
  <Icons.settings size={22} />
</button>

{sidebarOpen && (
  <div
    className="kitchen-sidebar-overlay"
    onClick={() => setSidebarOpen(false)}
  />
)}


        {/* SIDEBAR */}
        <div className={`kitchen-sidebar ${sidebarOpen ? "open" : ""}`}>
          {/* HEADER */}
          <div className="ks-header">
            {(infoLocale?.logoUrl || infoLocale?.logo) && (
              <img
                src={infoLocale.logoUrl || infoLocale.logo}
                className="ks-logo"
                alt="logo"
              />
            )}
            <div className="ks-title-main">
              Cucina
            </div>
          </div>

{/* DEMO NAVIGATION */}
{isDemo && (
  <div className="ks-card">
    <div className="ks-card-title">
      Demo
    </div>

    <button
  onClick={tornaAllaDashboardDemo}
  className="ks-btn-secondary"
  style={{
    width: "100%",
    justifyContent: "center"
  }}
>
  <div
  style={{
    display: "flex",
    alignItems: "center",
    gap: "6px"
  }}
>
  <span style={{ fontSize: "16px" }}>←</span>
  <span>Torna Dashboard</span>
</div>
</button>
  </div>
)}

          {/* CARD SISTEMA */}
          <div className="ks-card">
            <div className="ks-card-title">Sistema</div>

            <div className="ks-row">
              <span>🔊</span>
              <IOSSwitch value={audioAbilitato} onChange={() => setAudioAbilitato(p => !p)} />
            </div>

            <div className="ks-row">
              <span>🔔</span>
              <IOSSwitch value={notificationsEnabled} onChange={togglePush} />
            </div>

            {/* 🔥 NUOVO: SELETTORE VISTA */}
            <div style={{ marginTop: "6px" }}>
              <div className="ks-card-title">Vista</div>

              <div style={{
                display: "flex",
                gap: "6px",
                marginTop: "6px",
                flexWrap: "wrap"
              }}>
                <button
                  onClick={() => {
                    setVistaCompleta(false);
                    setVistaCategoria(false);
                  }}
                  className={`filter-chip ${!vistaCompleta && !vistaCategoria ? "active" : ""}`}
                  style={{ flex: "1 1 45%", minWidth: "110px" }}
                >
                  ⚡ Sintetico
                </button>

                <button
                  onClick={() => {
                    setVistaCompleta(true);
                    setVistaCategoria(false);
                  }}
                  className={`filter-chip ${vistaCompleta && !vistaCategoria ? "active" : ""}`}
                  style={{ flex: "1 1 45%" }}
                >
                  📋 Completo
                </button>

                <button
                  onClick={() => {
                    setVistaCategoria(true);
                    setVistaCompleta(false);
                  }}
                  className={`filter-chip ${vistaCategoria ? "active" : ""}`}
                  style={{ flex: "1 1 45%" }}
                >
                  🏷️ Categoria
                </button>
              </div>
            </div>

          </div>

          {/* CARD STATO */}
          <div className="ks-card">
            <div className="ks-card-title">Stato</div>

            <div className="ks-chip-group">
              {["", "inviato", "in attesa", "in preparazione", "pronto"].map(stato => {
                const count = ordini.filter(o => !stato || o.stato === stato).length;

                return (
                  <button
                    key={stato}
                    onClick={() => {
                      if (stato === "") {
                        setFiltroStato([]);
                        return;
                      }

                      setFiltroStato(prev => {
                        if (prev.includes(stato)) {
                          return prev.filter(s => s !== stato);
                        } else {
                          return [...prev, stato];
                        }
                      });
                    }}
                    className={`filter-chip ${
                      (stato === "" && filtroStato.length === 0) ||
                      filtroStato.includes(stato)
                        ? "active"
                        : ""
                    }`}
                  >
                    {stato === "" ? "Tutti" : stato} {count > 0 && `(${count})`}
                  </button>
                );
              })}
            </div>
          </div>

          {/* CARD TIPO */}
          <div className="ks-card">
            <div className="ks-card-title">Tipo</div>

            <div className="ks-chip-group">
              <button onClick={() => setFiltroTipo("")} className={`filter-chip ${filtroTipo === "" ? "active" : ""}`}>Tutti</button>
              <button onClick={() => setFiltroTipo("SALA")} className={`filter-chip ${filtroTipo === "SALA" ? "active" : ""}`}>Sala</button>
              <button onClick={() => setFiltroTipo("ASPORTO")} className={`filter-chip ${filtroTipo === "ASPORTO" ? "active" : ""}`}>Asporto</button>
            </div>
          </div>

          {/* CARD AZIONI */}
          <div className="ks-card">
            <div className="ks-card-title">Azioni</div>

{!isIOS && (
  <div className="ks-row">
    <div style={{ display: "flex", flexDirection: "column" }}>
      <span style={{ fontWeight: 600 }}>🖨️ Stampa automatica</span>
      <small style={{ color: "#8E8E93", marginTop: 2 }}>
        Stampa automaticamente i nuovi ordini
      </small>
    </div>

    <IOSSwitch
      value={stampaAutomatica}
      onChange={() => {
        setStampaAutomatica(prev => {
const nuovo = !prev;

localStorage.setItem("stampaAutomaticaCucina", String(nuovo));
stampaAutomaticaRef.current = nuovo;

if (nuovo) {
  ordiniStampatiRef.current.clear();
  stampeInCodaRef.current.clear();
  codaStampaRef.current = [];
  primoSnapshotOrdiniRef.current = false;
} else {
  codaStampaRef.current.forEach(({ itemKeys }) => {
    itemKeys.forEach(key => {
      stampeInCodaRef.current.delete(key);
    });
  });

  codaStampaRef.current = [];
}

          return nuovo;
        });
      }}
    />
  </div>
)}

{!/iPad|iPhone|iPod/.test(navigator.userAgent) && (
  <button
    className="ks-btn-secondary"
    onClick={() => setShowQrPrintConfig(true)}
  >
    <Icons.print size={16}/> Configura QrPrint
  </button>
)}

            <button className="ks-btn-secondary" onClick={() => setModaleCategorie(true)}>
              <Icons.settings size={16}/> Categorie
            </button>
          </div>

        </div>

        {/* CONTENUTO */}
        <div className="kitchen-content">


        {messaggio && (
          <div style={{
            backgroundColor: messaggio.startsWith("✅") ? "#d0f0c0" : "#f8d7da",
            color: messaggio.startsWith("✅") ? "#2e7d32" : "#721c24",
            padding: "0.8rem", borderRadius: "8px", marginBottom: "1rem",
            textAlign: "center", fontWeight: "bold"
          }}>{messaggio}</div>
        )}



        {cardsFiltrate.length === 0 ? (
  <p style={{ textAlign: "center", fontSize: "1.2rem", color: "#8B7355", padding: "2rem" }}>
    ✅ Nessun ordine da preparare.
  </p>
) : vistaCategoria ? (

  <div className="orders-grid-container">
    {Object.entries(colonneCategoria).map(([cat, lista]) => (
      <div key={cat}>
        <div style={{
          color: "#0a84ff",
          fontWeight: 800,
          marginBottom: 10
        }}>
          🏷️ {cat}
        </div>
        {lista.map(renderCard)}
      </div>
    ))}
  </div>

) : (

  <div className="orders-grid-container">

    <div>
      <div style={{
        color: countNuovi > 10 ? "#ff3b30" : "#4aa3ff",
        fontWeight: 800,
        marginBottom: 10
      }}>
        <Icons.circle size={10} color="#4aa3ff" /> NUOVI ({countNuovi})
      </div>

      {colonne["inviato"].map(renderCard)}

      <div style={{
        color: "#9C27B0",
        fontWeight: 800,
        margin: "12px 0 6px"
      }}>
        <Icons.circle size={10} color="#9C27B0" /> ATTESA ({countAttesa})
      </div>

      {colonne["in attesa"].map(renderCard)}
    </div>

    <div>
      <div style={{
        color: "#ff8c00",
        fontWeight: 800,
        marginBottom: 10,
        display: "flex",
        alignItems: "center",
        gap: 6
      }}>
        <Icons.kitchen size={14} color="#ff8c00" /> IN PREPARAZIONE
      </div>

      {colonne["in preparazione"].map(renderCard)}
    </div>

    <div>
      <div style={{
        color: "#00ff88",
        fontWeight: 800,
        marginBottom: 10
      }}>
        <Icons.check size={14} color="#00ff88" /> PRONTI
      </div>

      {colonne["pronto"].map(renderCard)}
    </div>

  </div>

)}

        {/* ── Drawer dettaglio ordine ── */}
        {cardAperta && (() => {
          const card = cardAperta;
          if (!card) return null;

          const selSet = selezione[card._key] || new Set();
          const hasSel = selSet.size > 0;
          const sc = STATO_COLORE[card.stato] || STATO_COLORE["inviato"];
          const gruppiArray = Object.entries(card.gruppi || {});

          const itemVisibilePerCategoria = (item) => {
            const nomePiatto = item.name || item.nome || "";
            const categoriaItem = getCategoriaByName(nomePiatto);

            return categorieSelezionate.includes(categoriaItem);
          };

          const gruppiSala = gruppiArray.filter(([_, g]) => g.tipoOrdine !== "ASPORTO" && !g.telefonoCliente);
          const gruppiSpeciali = gruppiArray
            .filter(([_, g]) => g.tipoOrdine === "ASPORTO" || !!g.telefonoCliente)
            .map(([ordineId, gruppo]) => [ordineId, {
              ...gruppo,
              items: ordinaPerStato(
                (gruppo.items || []).filter(itemVisibilePerCategoria)
              )
            }])
            .filter(([_, gruppo]) => gruppo.items.length > 0);
          const itemsSalaUnificati =
            gruppiSala.flatMap(([_, g]) => g.items || [])
              .filter(itemVisibilePerCategoria);

          const renderItem = (p) => {
            const key = `${p._ordineId}_${p._localIdx}`;
            const isSelected = p._groupItems
              ? p._groupItems.every(it => selSet.has(`${it._ordineId}_${it._localIdx}`))
              : selSet.has(key);
            const psc = STATO_COLORE[p._statoItem] || STATO_COLORE["inviato"];
            return (
              <div key={p._reactKey || key} onClick={() => {
                if (p._groupItems) {
                  p._groupItems.forEach(it => toggleItem(card._key, it._ordineId, it._localIdx));
                } else {
                  toggleItem(card._key, p._ordineId, p._localIdx);
                }
              }} style={{
                display: "flex", alignItems: "center", gap: "10px",
                padding: "10px", marginBottom: "6px", borderRadius: "12px", cursor: "pointer",
                background: isSelected ? "rgba(10,132,255,0.2)" : p.custom ? "rgba(255,80,80,0.12)" : "rgba(255,255,255,0.04)",
                border: p.custom ? "1px solid rgba(255,80,80,0.35)" : "1px solid rgba(255,255,255,0.04)"
              }}>
                <div onClick={(e) => {
                  e.stopPropagation();
                  if (p._groupItems) {
                    p._groupItems.forEach(it => toggleItem(card._key, it._ordineId, it._localIdx));
                  } else {
                    toggleItem(card._key, p._ordineId, p._localIdx);
                  }
                }} style={{
                  width: 18, height: 18, borderRadius: 4, flexShrink: 0,
                  border: isSelected ? "2px solid #0a84ff" : "2px solid #555",
                  backgroundColor: isSelected ? "#0a84ff" : "transparent",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  fontSize: "11px", fontWeight: "700", color: "#fff"
                }}>
                  {isSelected && "✓"}
                </div>
                <div style={{ flex: 1 }}>
                  <div style={{ fontWeight: "700", color: p.custom ? "#ff4d4f" : "#fff", fontSize: "0.92rem" }}>
                    {p.quantity} × {(p.name || p.nome)}
                  </div>
                  {p.custom && (
                    <div style={{ marginTop: "3px", padding: "4px 6px", borderRadius: "6px", backgroundColor: "rgba(255,80,80,0.18)", border: "1px solid rgba(255,80,80,0.4)", color: "#ff4d4f", fontSize: vistaCompleta ? "0.9rem" : "0.75rem", fontWeight: "600", display: "inline-block" }}>
                      📝 {p.custom}
                    </div>
                  )}
                </div>
                <span style={{ fontSize: "0.7rem", padding: "5px 9px", borderRadius: "999px", background: psc.bg, color: psc.text, border: `1px solid ${psc.border}`, fontWeight: "700", flexShrink: 0 }}>
                  {p._statoItem}
                </span>
              </div>
            );
          };

          return (
            <div
              onClick={() => { setCardAperta(null); deselTutti(card._key); }}
              style={{
                position: "fixed", inset: 0, zIndex: 9000,
                background: "rgba(0,0,0,0.65)", backdropFilter: "blur(4px)",
                display: "flex", alignItems: "flex-end", justifyContent: "center"
              }}
            >
              {/* Pannello — flex column con header/footer fissi e body scrollabile */}
              <div
                onClick={e => e.stopPropagation()}
                style={{
                  width: "100%",
                  maxWidth: "560px",
                  height: "88vh",
                  display: "flex",
                  flexDirection: "column",
                  minHeight: 0,
                  background: "#18191f",
                  borderRadius: "20px 20px 0 0",
                  boxShadow: "0 -8px 40px rgba(0,0,0,0.6)",
                  border: `2px solid ${sc.border}`,
                  borderBottom: "none",
                  overflow: "visible"
                }}
              >
                {/* ── HEADER FISSO ── */}
                <div style={{ flexShrink: 0, minHeight: 0 }}>
                  {/* Handle */}
                  <div style={{ display: "flex", justifyContent: "center", padding: "10px 0 4px" }}>
                    <div style={{ width: 36, height: 4, borderRadius: 2, background: "rgba(255,255,255,0.18)" }} />
                  </div>
                  {/* Titolo + stato + chiudi */}
                  <div style={{ padding: "8px 16px 12px", borderBottom: "1px solid rgba(255,255,255,0.07)", display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                    <div>
                      <div style={{ fontSize: "1.1rem", fontWeight: "800", color: "#fff", display: "flex", gap: "6px", alignItems: "center" }}>
                        {card.tipoOrdine === "ASPORTO"
                          ? <>
                              <Icons.takeaway size={18} color="#fff" />
                              #{card.numeroOrdineAsporto}
                            </>
                          : <>
                              <Icons.table size={18} color="#fff" />
                              Tav. {card.table}
                            </>
                        }
                      </div>
                      {card.telefonoCliente && <div style={{ fontSize: "0.78rem", color: "#aaa", marginTop: "2px" }}>📞 {card.telefonoCliente}</div>}
                      {card.tipoOrdine === "ASPORTO" && card.slotAsporto && (
  <div style={{
    fontSize: "0.9rem",
    color: "#ffb74d",
    marginTop: "4px",
    fontWeight: "800"
  }}>
    ⏰ Ritiro ore {card.slotAsporto}
  </div>
)}
<div style={{ fontSize: vistaCompleta ? "0.9rem" : "0.75rem", color: "#666", marginTop: "2px" }}>
                        <Icons.clock size={14} color="#aaa" /> {card.timestamp?.seconds ? new Date(card.timestamp.seconds * 1000).toLocaleString("it-IT") : ""}
                      </div>
                    </div>
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                      <span style={{ fontSize: "0.7rem", fontWeight: "700", padding: "4px 10px", borderRadius: "999px", background: sc.bg, color: sc.text, border: `1px solid ${sc.border}`, textTransform: "uppercase" }}>
                        {card.stato}
                      </span>
                      <button onClick={() => { setCardAperta(null); deselTutti(card._key); }} style={{ background: "rgba(255,255,255,0.08)", border: "none", borderRadius: "50%", width: 28, height: 28, color: "#aaa", cursor: "pointer", fontSize: "0.9rem", display: "flex", alignItems: "center", justifyContent: "center" }}>✕</button>
                    </div>
                  </div>
                  {/* Barra selezione — fa parte dell'header fisso */}
                  <div style={{ padding: "10px 16px 8px", borderBottom: "1px solid rgba(255,255,255,0.07)", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <span style={{ fontSize: "0.72rem", color: "#888" }}>
                      {hasSel ? `${selSet.size} selezionat${selSet.size === 1 ? "o" : "i"} — tocca per deselezionare` : "Tocca un piatto per selezionarlo"}
                    </span>
                    <div style={{ display: "flex", gap: "4px" }}>
                      <button
                        onClick={() => {
                          const allKeys = gruppiArray.flatMap(([_, g]) =>
                            (g.items || []).map(p => `${p._ordineId}_${p._localIdx}`)
                          );
                          selTutti(card._key, allKeys);
                        }}
                        style={{ fontSize: "0.68rem", padding: "2px 7px", borderRadius: "4px", border: "1px solid #555", background: "transparent", color: "#bbb", cursor: "pointer" }}
                      >
                        ☑ Tutti
                      </button>
                      {hasSel && (
                        <button onClick={() => deselTutti(card._key)} style={{ fontSize: "0.68rem", padding: "2px 7px", borderRadius: "4px", border: "1px solid #f44336", background: "transparent", color: "#f44336", cursor: "pointer" }}>✕</button>
                      )}
                    </div>
                  </div>
                </div>

                {/* ── BODY SCROLLABILE ── */}
                <div
  onTouchMove={(e) => e.stopPropagation()}
  style={{
    flex: 1,
    minHeight: 0,
    display: "flex",
    flexDirection: "column",
    overflowY: "auto",
    touchAction: "pan-y",
                    overflowX: "hidden",
                    padding: "12px 16px 8px",
                    WebkitOverflowScrolling: "touch",
                    overscrollBehavior: "contain"
                  }}
                >
                  {itemsSalaUnificati.length > 0 && (
                    <div
                      style={{
                        marginBottom: "10px",
                        padding: "6px",
                        borderRadius: "10px",
                        background: "rgba(255,255,255,0.025)",
                        border: "1px solid rgba(255,255,255,0.06)",
                        flexShrink: 0 // 🔥 QUESTO È IL FIX
                      }}
                    >
                      <div style={{ fontSize: vistaCompleta ? "0.9rem" : "0.75rem", fontWeight: "600", marginBottom: "6px", color: "#bbb" }}>👨‍🍳 Sala</div>
                      {(() => {
                        const grouped = {};
                        itemsSalaUnificati.forEach((item) => {
                          const nome = item.name || item.nome || "";
                          const key = `${nome}_${item.custom || ""}_${item._statoItem}`;
                          if (!grouped[key]) grouped[key] = { ...item, quantity: 0, _items: [] };
                          grouped[key].quantity += item.quantity ?? item.quantita ?? 1;
                          grouped[key]._items.push(item);
                        });
                        return ordinaPerStato(Object.values(grouped)).map((item) => {
                          const first = item._items[0];
                          const nome = first.name || first.nome || "";
                          const groupKey = `${nome}_${first.custom || ""}_${first._statoItem}`;

                          return renderItem({
                            ...first,
                            quantity: item.quantity,
                            _groupItems: item._items,
                            _reactKey: groupKey
                          });
                        });
                      })()}
                    </div>
                  )}
                  {gruppiSpeciali.map(([ordineId, gruppo]) => (
                    <div
                      key={ordineId}
                      style={{
                        marginBottom: "10px",
                        padding: "6px",
                        borderRadius: "10px",
                        background: "rgba(255,255,255,0.025)",
                        border: "1px solid rgba(255,255,255,0.06)",
                        flexShrink: 0 // 🔥 QUESTO È IL FIX
                      }}
                    >
                      <div style={{ fontSize: vistaCompleta ? "0.9rem" : "0.75rem", fontWeight: "600", marginBottom: "6px", color: "#bbb" }}>
                        {gruppo.tipoOrdine === "ASPORTO"
                          ? <><Icons.takeaway size={14} color="#fff" /> Asporto</>
                          : <><Icons.table size={14} color="#fff" /> Sala</>
                        }
                      </div>
                      {gruppo.items.map(renderItem)}
                    </div>
                  ))}
                </div>

                {/* ── FOOTER FISSO ── */}
                <div style={{ flexShrink: 0, padding: "8px 16px calc(env(safe-area-inset-bottom, 0px) + 12px)", borderTop: "1px solid rgba(255,255,255,0.07)", background: "#18191f" }}>
                  {hasSel && (
                    <div style={{ fontSize: "0.72rem", color: "#FFB74D", fontWeight: 600, marginBottom: "8px", textAlign: "center" }}>
                      Cambia stato a {selSet.size} piatt{selSet.size === 1 ? "o" : "i"} selezionat{selSet.size === 1 ? "o" : "i"}
                    </div>
                  )}
                  <button
                    onClick={() => {
                      setCardAperta(null);
                      deselTutti(card._key);
                    }}
                    style={{
                      width: "100%",
                      marginBottom: "8px",
                      padding: "12px",
                      borderRadius: "10px",
                      border: "none",
                      background: "rgba(255,255,255,0.08)",
                      color: "#fff",
                      fontWeight: "700",
                      fontSize: "0.9rem",
                      cursor: "pointer"
                    }}
                  >
                    ✕ Chiudi scheda
                  </button>
                  <div className="azioni-ordine" style={{ flexWrap: "wrap" }}>
                    <button className="btn-stato attesa" onClick={() => aggiornaStato(card, "in attesa")}> 
                      <Icons.timer size={18} color="#fff" />
                    </button>

                    <button className="btn-stato prep" onClick={() => aggiornaStato(card, "in preparazione")}> 
                      <Icons.kitchen size={18} color="#fff" />
                    </button>

                    <button className="btn-stato pronto" onClick={() => aggiornaStato(card, "pronto")}> 
                      <Icons.check size={18} color="#fff" />
                    </button>

{!isIOS && (
  <button className="btn-stampa" onClick={() => stampaOrdine(card)}>
    <Icons.print size={16} color="#fff" />
    <span>Stampa</span>
  </button>
)}
                  </div>
                </div>
              </div>
            </div>
          );
        })()}
      </div>
    </div>

{/* Modale QrPrint */}
{showQrPrintConfig && (
<div
  onClick={() => setShowQrPrintConfig(false)}
  style={{
    position: "fixed",
    inset: 0,
    backgroundColor: "rgba(0,0,0,0.65)",
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "center",
    zIndex: 99999,
    padding: "16px",
    paddingTop: "70px",
    overflowY: "auto",
    WebkitOverflowScrolling: "touch"
  }}
>
    <div
      onClick={e => e.stopPropagation()}
      style={{
  background: "#1c1c1e",
  borderRadius: "18px",
  padding: "1.4rem",
  maxWidth: "440px",
  width: "92%",
  maxHeight: "calc(100dvh - 100px)",
  overflowY: "auto",
  WebkitOverflowScrolling: "touch",
  boxSizing: "border-box",
  border: "1px solid rgba(255,255,255,0.08)",
  boxShadow: "0 10px 40px rgba(0,0,0,0.65)"
}}
    >
      <h3 style={{ marginTop: 0, color: "#fff" }}>
        🖨️ Configura QrPrint
      </h3>

      <p style={{ color: "#aaa", lineHeight: 1.5, fontSize: "0.92rem" }}>
  Usa questo codice locale nell’app QrPrint per collegare questo dispositivo
  cucina alla stampa degli ordini del locale.
</p>

      <div
        style={{
          marginTop: "1rem",
          marginBottom: "1rem",
          background: "rgba(10,132,255,0.14)",
          border: "1px solid rgba(10,132,255,0.35)",
          borderRadius: "14px",
          padding: "1rem",
          textAlign: "center"
        }}
      >
        <div style={{ color: "#8E8E93", fontSize: "0.78rem", marginBottom: "0.4rem" }}>
          Codice locale
        </div>

        <div
          style={{
            color: "#fff",
            fontWeight: "800",
            fontSize: "1.25rem",
            letterSpacing: "1px"
          }}
        >
          {localeTag}
        </div>
      </div>
<button
  onClick={async () => {
    try {
      await navigator.clipboard.writeText(localeTag || "");
      setMessaggio("✅ Codice locale copiato");
      setTimeout(() => setMessaggio(""), 2000);
    } catch (e) {
      console.error("❌ Errore copia codice locale:", e);
    }
  }}
  style={{
    width: "100%",
    padding: "0.75rem",
    borderRadius: "12px",
    border: "1px solid rgba(255,255,255,0.12)",
    background: "rgba(255,255,255,0.06)",
    color: "#fff",
    fontWeight: "700",
    cursor: "pointer",
    marginBottom: "1rem"
  }}
>
  📋 Copia codice locale
</button>

      <div
        style={{
          background: "rgba(255,255,255,0.04)",
          borderRadius: "14px",
          padding: "0.9rem",
          color: "#aaa",
          fontSize: "0.88rem",
          lineHeight: 1.5,
          marginBottom: "1rem"
        }}
      >
        <strong style={{ color: "#fff" }}>Come configurare:</strong>
        <br />
        1. Apri QrPrint sul dispositivo cucina.
        <br />
        2. Inserisci il codice locale mostrato sopra.
        <br />
        3. Configura IP e porta della stampante ESC/POS.
        <br />
        4. Fai una stampa di prova.
      </div>

      {/Android/i.test(navigator.userAgent) && (
        <button
          onClick={() => {
            window.open("https://firebasestorage.googleapis.com/v0/b/qrzone-menuvivo.firebasestorage.app/o/apk%2FQrPrint.apk?alt=media&token=5d02638a-1e6c-45ca-b7ba-4152e61039cf", "_blank");
          }}
          style={{
            width: "100%",
            padding: "0.85rem",
            borderRadius: "12px",
            border: "none",
            background: "#0A84FF",
            color: "#fff",
            fontWeight: "700",
            cursor: "pointer",
            marginBottom: "0.8rem"
          }}
        >
          📥 Scarica QrPrint APK
        </button>
      )}

      <button
        onClick={() => setShowQrPrintConfig(false)}
        style={{
          width: "100%",
          padding: "0.85rem",
          borderRadius: "12px",
          border: "none",
          background: "rgba(255,255,255,0.1)",
          color: "#fff",
          fontWeight: "700",
          cursor: "pointer"
        }}
      >
        Chiudi
      </button>
    </div>
  </div>
)}

      {/* Modale categorie */}
      {modaleCategorie && (
        <div onClick={() => setModaleCategorie(false)} style={{ position: "fixed", inset: 0, backgroundColor: "rgba(0,0,0,0.6)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9999 }}>
          <div onClick={e => e.stopPropagation()} style={{
            background: "#1c1c1e",
            borderRadius: "16px",
            padding: "1.8rem",
            maxWidth: "420px",
            width: "90%",
            border: "1px solid rgba(255,255,255,0.08)",
            boxShadow: "0 10px 40px rgba(0,0,0,0.6)"
          }}>
            <h3 style={{ marginTop: 0, color: "#fff" }}>🍽️ Categorie visibili in cucina</h3>
            <p style={{ fontSize: "0.9rem", color: "#aaa", marginBottom: "1rem" }}>Nascondi le categorie che non servono in cucina</p>
            <div style={{ maxHeight: "250px", overflowY: "auto", border: "1px solid rgba(255,255,255,0.08)", borderRadius: "8px", padding: "0.8rem", marginBottom: "1.5rem", backgroundColor: "rgba(255,255,255,0.04)" }}>
              {categorieDisponibili.length === 0
                ? <p style={{ color: "#999", textAlign: "center", margin: 0 }}>Nessuna categoria</p>
                : categorieDisponibili.map((cat, i) => (
                  <label key={i} style={{ display: "flex", alignItems: "center", gap: "0.5rem", padding: "0.4rem", borderRadius: "4px", cursor: "pointer" }}
                    onMouseEnter={e => e.currentTarget.style.backgroundColor = "#f0f0f0"}
                    onMouseLeave={e => e.currentTarget.style.backgroundColor = "transparent"}>
                    <input type="checkbox" checked={categorieSelezionate.includes(cat)}
                      onChange={e => setCategorieSelezionate(prev => e.target.checked ? [...prev, cat] : prev.filter(c => c !== cat))}
                      style={{ width: 18, height: 18, cursor: "pointer" }} />
                    <span style={{ color: "#ddd" }}>{cat}</span>
                  </label>
                ))}
            </div>
            <div style={{ display: "flex", gap: "0.8rem" }}>
              <button onClick={salvaCategorieVisibili} style={{ flex: 1, padding: "0.7rem", background: "#0a84ff", color: "#fff", border: "none", borderRadius: "6px", fontWeight: 600, cursor: "pointer" }}>💾 Salva</button>
              <button onClick={() => setModaleCategorie(false)} style={{ flex: 1, padding: "0.7rem", background: "rgba(255,255,255,0.1)", color: "#fff", border: "none", borderRadius: "6px", fontWeight: 600, cursor: "pointer" }}>Annulla</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default DashboardCucina;